<template>
  <div class="upload-chart">
    <ul>
      <li class="file-list" v-for="(item, i) in quesInfo.parseUploadList" :key="i">
        <p class="file-item" v-if="item.filePath">
          {{item.fileName}}
          <el-button size="small" type="text" @click="exportFile(item)">下载</el-button>
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "uploadChart",
  props: ["quesInfo"],
  methods: {
    exportFile(item) {
      const aLink = document.createElement("a");
      aLink.download = item.fileName;
      aLink.href = item.filePath;
      aLink.style.display = "none";
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    }
  }
};
</script>

<style lang="scss">
.upload-chart {
  overflow: hidden;
  .file-list {
    float: left;
    padding: 0 15px;
  }
  .file-item {
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/singleAnalysis/uploadChart.vue